import { Role } from "../../../services/project/get-project/GetProjectResponse";
import {
  DisplayColumn,
  ErrorMessage,
} from "../../../util/spreadsheet-data-utils";

export type ProjectStakeholderListState = {
  isShow: boolean;
  reqReload: boolean;
  saved: Stakeholder[];
  edited: Stakeholder[];
  invalidRoleList?: Role[];
  codes: {
    inDefCommonFlagTypeCd?: Option[];
    roleCdList?: Option[];
  };
  displayColumn: DisplayColumn[];
  displayFilter: String;
  fromActionList: boolean;
  fromActionListParam?: {
    primFlg: string;
    roleCd: string;
    teamCd: string;
  };
  pjtId: string;
  pjtTypeCd: string;
  updateDateTime: string;
  status: {
    invalidList: string[];
    invalidRecordList: string[];
    isSaved: boolean;
  };
  spreadsheet: {
    selectRowIdx?: number;
    tmplateRow: SpreadsheetRecordData;
  };
};

export type Stakeholder = {
  stkhldrId: string;
  primFlg: string;
  roleCd: string;
  roleName: string;
  teamCd: string;
  userId: string;
  userName: string;
  mlAdrs: string;
  stkhldrNote?: string;
  userRoleList?: UserRoleList[];
};

export type UserRoleList = {
  roleCd: string;
  roleName: string;
  cvrgCd: string;
  primFlg: string;
};

export type Option = {
  label: string;
  value: string;
  cvrgType?: string;
};

export type CellItem = {
  rowIdx: number;
  col: string;
};

export type SpreadsheetState = {
  results: SpreadsheetRecordData[];
  codes?: {
    inDefCommonFlagTypeCd: Option[];
  };
};

export type SpreadsheetRecordData = {
  isAddRow: boolean;
  updateFlag?: boolean;
  stkhldrId: string;
  primFlg: string;
  roleCd: string;
  roleName: string;
  teamCd: string;
  userId: string;
  userName: string;
  mlAdrs: string;
  stkhldrNote: string;
  userRoleList?: UserRoleList[];
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export type LoadedRecordData = {
  primFlg: string;
  teamCd: string;
  roleName: string;
  userId: string;
  stkhldrNote: string;
  stkhldrId: string;
};

export type PageNewState =
  | ProjectStakeholderListState
  | ((prevState: ProjectStakeholderListState) => ProjectStakeholderListState);
